import { HStack, Icon, IconName } from '@talos/kyoko';
import { startCase } from 'lodash-es';
import { Fragment } from 'react';
import type { LayoutSection } from '../../types/LayoutConfig';

export function LayoutSectionBreadcrumb({ layoutSection }: { layoutSection: LayoutSection }) {
  const layoutSectionParts = layoutSection
    .split('/')
    .filter(part => part !== '')
    .map(part => startCase(part));

  return (
    <HStack gap="spacing4">
      {layoutSectionParts.flatMap((part, i) =>
        i === 0
          ? [<Fragment key={part}>{part}</Fragment>]
          : [<Icon key={`sep-${i}`} icon={IconName.ChevronRight} />, <Fragment key={part}>{part}</Fragment>]
      )}
    </HStack>
  );
}
